export function getHeaders(authToken) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  if (authToken) headers['Authentication-Token'] = authToken

  return headers
}
